const ToggleRight = ({ color, type }) => {
  const regular = (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0833 27.0833H12.9167C9.00465 27.0833 5.83333 23.912 5.83333 20C5.83333 16.088 9.00465 12.9167 12.9167 12.9167H27.0833M27.0833 27.0833C30.9953 27.0833 34.1667 23.912 34.1667 20C34.1667 16.088 30.9953 12.9167 27.0833 12.9167M27.0833 27.0833C23.1713 27.0833 20 23.912 20 20C20 16.088 23.1713 12.9167 27.0833 12.9167"
        stroke={color}
        strokeWidth="3.33333"
      />
      <circle cx="28" cy="20" r="7" fill={color} />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default ToggleRight;
